<template>
  <div>
    <div class="land-home-carousel">
      <div style="width:1200px; margin:0 auto">
        <div class="solution-banner-title">NEWS</div>
        <div class="solution-banner-text">动态</div>
      </div>
    </div>
  </div>
</template>

<script>
// const bannerUrl = require('../../../../../../assets/images/land-page/land-home/construction-banner.png')
export default {
  name: 'landDynamicBanner',
  data () {
    return {
      // bannerUrl: bannerUrl
    }
  }
}
</script>

<style lang="scss" scoped>
.land-home-carousel {
  // width: 1920px;
  width: 100%;
  height: 367px;
  margin: auto;
  background-color: #4499ff;
  background: url("../../../../../../assets/images/land-page/land-home/news-banner.jpg")
    no-repeat;
  background-size: cover;
  display: flex;
  // img {
  //   // height:367px ;
  //   display: block;
  //   width: 100%;
  //   height: 100%;
  // }

  .solution-banner-title {
    margin-top: 143px;
    // margin-left: 362px;
    font-size: 48px;
    font-weight: normal;
    color: #ffffff;
    line-height: 54px;
    letter-spacing: 3px;
  }
  .solution-banner-text {
    margin-top: 2px;
    // margin-left: 362px;
    font-size: 28px;
    font-weight: normal;
    color: #ffffff;
    line-height: 32px;
    letter-spacing: 2px;
  }
}
</style>
